import { Horario } from "../types/horario.type";
import ApiService from "./apiService";

const endpoint = "/api/v1/negocios/horarios";

class HorariosService extends ApiService {
  getAll() {
    return this.get<Horario[]>(endpoint, {
      negocioActivo: true,
    });
  }

  update(horarios: Horario[]) {
    return this.put<Horario[]>(
      endpoint,
      { horarios },
      {
        negocioActivo: true,
      }
    );
  }
}

const horariosService = new HorariosService();
export default horariosService;
